import Icon from '../components/Icon.vue'

Icon.register({
  flushed: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M344 200c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM152 200c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM80 224c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72zM312 400c21.2 0 21.2-32 0-32h-128c-21.2 0-21.2 32 0 32h128zM344 296c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72z'
      }
    ]
  }
})
